export default __webpack_public_path__ + "static/media/featured_course_img_1.37be703b.png";